// @ts-strict-ignore
import {
  Component,
  ElementRef,
  Input,
} from '@angular/core';

@Component({
  selector: '[lm-code-block]', // tslint:disable-line
  template: `<div class="list-code-block-container">
    <div class="code-block">
      <ng-content></ng-content>
    </div>
  </div>`,
})
export class LMCodeBlockComponent {

  @Input() layoutObject: LMFormLayoutElements;
  @Input() dataView: LMDataView;

  constructor(private elementRef: ElementRef) {
  }
}
